import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import SectionGaugeCard from '../ui/SectionGaugeCard'
import { formatNumber, formatPercent } from '../ui/KpiCard/status'

const EMPTY_TOOLTIP = 'Aucune note pour cette section'

const gaugeValueFor = (mode, { grade, satisfaction, gradeMax }) => {
  if (mode === 'grade')
    return Number.isFinite(grade) && gradeMax > 0 ? grade / gradeMax * 100 : null
  return Number.isFinite(satisfaction) ? satisfaction : null
}

const valueParts = (mode, { grade, satisfaction, gradeMax }) => {
  if (mode !== 'grade')
    return { main: formatPercent(satisfaction), suffix: null }
  if (!Number.isFinite(grade))
    return { main: '--', suffix: null }
  return { main: formatNumber(grade), suffix: `/${gradeMax}` }
}

const SectionGradeCard = ({
  id, name, grade, satisfaction, hasGradeQuestions, mode, gradeMax, onSelect
}) => {
  const handleSelect = useCallback(() => onSelect({ id, name }), [onSelect, id, name])
  const gaugeValue = gaugeValueFor(mode, { grade, satisfaction, gradeMax })
  const { main, suffix } = valueParts(mode, { grade, satisfaction, gradeMax })
  const showEmptyTooltip = mode === 'grade' && !hasGradeQuestions

  return (
    <SectionGaugeCard
      emptyTooltip={EMPTY_TOOLTIP}
      gaugeValue={gaugeValue}
      main={main}
      name={name}
      showEmptyTooltip={showEmptyTooltip}
      suffix={suffix}
      onClick={handleSelect}
    />
  )
}

SectionGradeCard.propTypes = {
  grade: PropTypes.number,
  gradeMax: PropTypes.number,
  hasGradeQuestions: PropTypes.bool,
  id: PropTypes.number.isRequired,
  mode: PropTypes.oneOf(['grade', 'satisfaction']),
  name: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  satisfaction: PropTypes.number
}

SectionGradeCard.defaultProps = {
  grade: null,
  gradeMax: 1,
  hasGradeQuestions: false,
  mode: 'satisfaction',
  satisfaction: null
}

export default SectionGradeCard
